import http from '@/utils/http';
import { Item, ListResult, SortCond } from '@/features/backlog/types';
import { SearchRequest } from './query';

/** Run the cross-board global search. Board access is enforced server-side. `prefer_board` ranks a
 *  given board's items first for a text query (e.g. the link picker prefers the current board). */
export const searchItems = (req: SearchRequest & { sort?: SortCond[]; prefer_board?: string }) =>
  http.post<ListResult<Item>>('/items/search', req).then((r) => r.data);

/** Distinct status labels across the caller's accessible boards (for the `status:` autocomplete). */
export const statusLabels = () => http.get<string[]>('/statuses/labels').then((r) => r.data);
